import AiLoader from "@dashboard/modules/shared/components/onboarding-shared/pages/ai-loader/ai-loader";
import { FC } from "react";

const OnboardingGenerating: FC = () => {
  return <AiLoader redirectPath="/onboarding/personalize" />;
};

export default OnboardingGenerating;
